import React from 'react'
import './oursponsors.css'
import Sponsor1 from '../../assets/images/sponsors/Sponsor1.jpg'
import Sponsor2 from '../../assets/images/sponsors/Sponsor2.jpg'
import Sponsor3 from '../../assets/images/sponsors/Sponsor3.jpg'
import Sponsor4 from '../../assets/images/sponsors/Sponsor4.jpg'
import Sponsor5 from '../../assets/images/sponsors/Sponsor5.jpg'
import Sponsor6 from '../../assets/images/sponsors/Sponsor6.jpg'
import Sponsor7 from '../../assets/images/sponsors/Sponsor7.jpg'
import Sponsor8 from '../../assets/images/sponsors/Sponsor8.jpg'
import Sponsor9 from '../../assets/images/sponsors/Sponsor9.jpg'
import Sponsor10 from '../../assets/images/sponsors/Sponsor10.jpg'
import Sponsor11 from '../../assets/images/sponsors/Sponsor11.jpg'
import Sponsor12 from '../../assets/images/sponsors/Sponsor12.jpg'
import Sponsor13 from '../../assets/images/sponsors/Sponsor13.jpg'
import Sponsor14 from '../../assets/images/sponsors/Sponsor14.jpg'
import Sponsor15 from '../../assets/images/sponsors/Sponsor15.jpg'
import Sponsor16 from '../../assets/images/sponsors/Sponsor16.jpg'
import Sponsor17 from '../../assets/images/sponsors/Sponsor17.jpg'
import Sponsor18 from '../../assets/images/sponsors/Sponsor18.jpg'

const OurSponsors = () => {
  return (
    <div className='sponsors'>
      <div className='slider'>
        <div className='slide-track'>
            <div className='slide'>
                <img src={Sponsor1} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor2} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor3} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor4} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor5} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor6} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor7} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor8} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor9} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor10} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor11} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor12} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor13} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor14} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor15} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor16} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor17} alt = "Sponsor" />
            </div>
            <div className='slide'>
                <img src={Sponsor18} alt = "Sponsor" />
            </div>
        </div>
      </div>
    </div>
  )
}

export default OurSponsors
